(function ($) {
  'use strict';

	$(document).ready(function() {
		initialize_header();
	});

  $(window).on('resize', function() {
    reset_header();
  });

  var $html = $('html'),
      $main_menu = $('.main-menu'),
      $active_parents = $('.submenu--revealed', $main_menu),
      $global_submenus = $('.main-menu__submenu-container', $main_menu),
      $active_submenus = $('.main-menu__submenu-container.active', $main_menu),
      $submenu_toggles = $('.main-menu__subnav-trigger', $main_menu),
      $third_level_toggles = $('.main-menu__thirdnav-trigger', $main_menu),
      $third_level_menus = $('.thirdnav-menu'),
      $mobile_menu_toggle = $('.main-menu__toggle'),
      $search_field = $('.header__search'),
      $search_toggle = $('.search-toggle'),
      $search_toggle_text = $search_toggle.find('span'),
      $toggable = $('.header__toggable'),
      $navigation = $('.header__navigation');

	function initialize_header() {
    // Mobile Navigation
    $mobile_menu_toggle.on('click', function() {
      // if search field not active
      if ( !$search_toggle.hasClass('active') ) {
        // if menu is not already active
        if ( !$(this).hasClass('active') ) {
          $(this).addClass('active')
            .attr('aria-label', 'Close Menu Navigation');

          $html.addClass('menu-is-open')
            .attr('draggable', false);

          $toggable.show();
          $navigation.show();

          setTimeout(function() {
            $toggable.addClass('active');
          }, 100);
        }
        // if menu is active
        else {
          $(this).removeClass('active')
            .attr('aria-label', 'Open Menu Navigation');

          $html.removeClass('menu-is-open')
            .attr('draggable', true);

          $toggable.removeClass('active');

          setTimeout(function() {
            $toggable.hide();
            $navigation.hide();
          }, 100);
        }
      }
      // if search field is active
      else {
        $search_toggle.removeClass('active')
          .attr('aria-label', 'Open Search Field');

        $search_field.hide();
        $(this).addClass('active');
        $navigation.slideDown();
      }
    });

    // Search
    $search_toggle.on('click', function() {
      // desktop
      if ( $mobile_menu_toggle.css('display') == 'none' ) {
        if ( !$(this).hasClass('active') ) {
          $(this).attr('aria-label', 'Close Search Field');
          $search_toggle_text.text('Close');
        }
        else {
          $(this).attr('aria-label', 'Open Search Field');
          $search_toggle_text.text('Open');
        }

        $(this).toggleClass('active')
        $search_field.toggle();
        $html.toggleClass('search-is-open');
      }
      // mobile
      else {
        // if menu is not active
        if ( !$mobile_menu_toggle.hasClass('active') ) {
          // if search is not already active
          if ( !$(this).hasClass('active') ) {
            $(this).addClass('active')
              .attr('aria-label', 'Close Search Field');

            $html.addClass('menu-is-open')
              .attr('draggable', false);

            $toggable.show();
            $search_field.show();

            setTimeout(function() {
              $toggable.addClass('active');
            }, 100);
          }
          // if search is active
          else {
            $(this).removeClass('active')
              .attr('aria-label', 'Open Search Field');

            $html.removeClass('menu-is-open')
              .attr('draggable', true);

            $toggable.removeClass('active');

            setTimeout(function() {
              $toggable.hide();
              $search_field.hide();
            }, 100);
          }
        }
        // if menu is active
        else {
          $mobile_menu_toggle.removeClass('active')
            .attr('aria-label', 'Open Menu Navigation');

          $navigation.hide();
          $(this).addClass('active');
          $search_field.slideDown();
        }
      }
    });

    $('#backToMenu').on('click',function() {
      $mobile_menu_toggle.trigger('click');
    })
  }

  // Reset header on window resize
  function reset_header() {
    // if desktop
    if ( $mobile_menu_toggle.css('display') == 'none' ) {
      // if mobile nav is open
      if ( $('.menu-is-open').length ) {
        $mobile_menu_toggle
          .removeClass('active')
          .attr('aria-label', 'Open Menu Navigation');

        $('.main-menu__item')
          .removeClass('submenu--revealed')
          .attr('aria-expanded', false);

        $toggable
          .show()
          .removeClass('active');

        $navigation.css('display','flex');
        $search_field.hide();

        $global_submenus
          .removeClass('active')
          .hide();

        $html
          .removeClass('menu-is-open')
          .attr('draggable', true);

        $search_toggle_text.text('Open');
        $search_toggle
          .removeClass('active')
          .attr('aria-label', 'Open Search Field');
      }
      else {
        $toggable.show();
        $navigation.css('display','flex');
        $search_field.hide();
      }
    }
    else {
      $navigation.hide();
      $search_field.hide();

      $mobile_menu_toggle
        .removeClass('active')
        .attr('aria-label', 'Open Menu Navigation');

      $('.main-menu__item')
        .removeClass('submenu--revealed')
        .attr('aria-expanded', false);

      $toggable
        .hide()
        .removeClass('active');

      $global_submenus
        .removeClass('active')
        .hide();

      $third_level_toggles
        .removeClass('active');

      $third_level_menus
        .hide();

      $html
        .removeClass('menu-is-open')
        .attr('draggable', true);

      $search_toggle
        .removeClass('active')
        .attr('aria-label', 'Open Search Field');

      $search_toggle_text
        .text('Open');

    }
  }

})(jQuery);
